import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getContentParameterList,
  getOfficialScenarioDetail,
  getOfficialScenarioList,
  getOfficialScenarioLogs,
} from 'services/api/pureLLM';
import type {
  ContentParameter,
  OfficialScenarioDetailParams,
  OfficialScenarioListParams,
  OfficialScenarioLogParams,
  OfficialScenarioLogResponse,
  IntentGroup,
  Scenario,
} from 'views/PureLLM/Types/api';

export const pureLLM = createQueryKeys('pureLLM', {
  scenarioList: (params: OfficialScenarioListParams) => ({
    queryKey: [params],
    queryFn: ({ signal }): Promise<IntentGroup[]> => getOfficialScenarioList(params, signal),
  }),
  scenarioDetail: (params: OfficialScenarioDetailParams) => ({
    queryKey: [params.intentId, params.language],
    queryFn: ({ signal }): Promise<Scenario> => getOfficialScenarioDetail(params, signal),
  }),
  operationLogs: (params: OfficialScenarioLogParams) => ({
    queryKey: [params],
    queryFn: ({ signal }): Promise<OfficialScenarioLogResponse> =>
      getOfficialScenarioLogs(params, signal),
  }),
  contentParameterList: (params: { language: string }) => ({
    queryKey: [params.language],
    queryFn: ({ signal }): Promise<ContentParameter[]> => getContentParameterList(params, signal),
  }),
});
